import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/v-tooltip.js